import { render, staticRenderFns } from "./postInvestigationRecord.vue?vue&type=template&id=2d859b74&scoped=true&"
import script from "./postInvestigationRecord.vue?vue&type=script&lang=ts&"
export * from "./postInvestigationRecord.vue?vue&type=script&lang=ts&"
import style0 from "./postInvestigationRecord.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./postInvestigationRecord.vue?vue&type=style&index=1&id=2d859b74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d859b74",
  null
  
)

export default component.exports